<template>
  <v-dialog v-model="show" max-width="440">
    <v-card v-if="payout">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>{{ formatCurrency(payout.amount, restaurantCurrency) }}</span>
        <v-chip small :color="statusMeta.color" text-color="white">
          {{ statusMeta.labelKey ? $t(statusMeta.labelKey) : "" }}
        </v-chip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div class="detail-row">
          <span>{{ $t("finance_bank_account") }}</span>
          <strong class="mono">{{ payout.bankAccount }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_payout_date") }}</span>
          <strong>{{ formatDate(payout.date) }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_reference") }}</span>
          <strong class="mono">{{ payout.reference }}</strong>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <primary-button block @click="$emit('pdf', payout)">
          <v-icon left small>mdi-file-pdf-box</v-icon>
          {{ $t("finance_pdf_statement") }}
        </primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { RESTAURANT_PAYOUT_STATUS_META, formatCurrency, formatDate } from "../constants";

export default {
  name: "RestaurantPayoutDetailDialog",

  props: {
    value: { type: Boolean, default: false },
    payout: { type: Object, default: null },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    statusMeta() {
      return (
        (this.payout && RESTAURANT_PAYOUT_STATUS_META[this.payout.status]) || {
          labelKey: "",
          color: "grey",
        }
      );
    },
  },

  methods: { formatCurrency, formatDate },
};
</script>

<style scoped>
.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
  padding: 4px 0;
}

.detail-row strong {
  color: rgba(0, 0, 0, 0.87);
  text-align: right;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.82rem;
}
</style>
